import React from 'react';
import PropTypes from 'prop-types';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { UnifiedLeadFormCustomConfigPropTypes } from 'site-modules/shared/components/lead-form/lead-form-prop-types/lead-form-prop-types';
import { makeNiceName } from 'site-modules/shared/utils/nice-name';
import { generateLeaseSrpLinkMakeModel } from 'site-modules/shared/utils/srp-link-constructor';
import { formatPriceStringV2 } from 'site-modules/shared/utils/price-utils';
import { FormViewDecorator } from 'site-modules/shared/components/lead-form/unified-lead-form/views/form-view-decorator';
import { Link } from 'site-modules/shared/components/link/link';

import './lease-deals-empty-view.scss';

function LeaseDealsEmptyViewUI({ make, model, customConfig = null }) {
  const makeSlug = makeNiceName(make);
  const modelSlug = makeNiceName(model);
  const payment = customConfig.payment;

  return (
    <Row className="lease-deals-empty-view pos-r">
      <Col xs={12} md={7} className="module d-flex flex-column bg-white p-1 p-md-1_5 rounded-12">
        <h2 className="heading-3 mb-2 text-blue-50">{`${formatPriceStringV2(payment)} ${make} ${model}`}</h2>
        <div className="heading-4 mb-1">Sorry!</div>
        <div className="mb-1">There are no dealers in our network near you.</div>

        <Link className="text-primary-darker mb-0_5" to={generateLeaseSrpLinkMakeModel(makeSlug, modelSlug)}>
          Search all {model} inventory
          <i className="icon small icon-arrow-right3 ms-0_25" aria-hidden />
        </Link>
      </Col>
    </Row>
  );
}

LeaseDealsEmptyViewUI.propTypes = {
  make: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  customConfig: UnifiedLeadFormCustomConfigPropTypes.leadFormConfig,
};

export const LeaseDealsEmptyView = FormViewDecorator(LeaseDealsEmptyViewUI);
